import React, { useState } from "react";
import { Tabs, Input, Checkbox, Card, Form, Button } from "antd";

const { TabPane } = Tabs;

const DynamicStep = () => {
    const [form] = Form.useForm();
    const [activeKey, setActiveKey] = useState();

    const saved = localStorage.getItem("goiThauData");

    let steps = {};

    if (saved) {
        const parsedData = JSON.parse(saved);
        steps =
        typeof parsedData.step === "string"
            ? JSON.parse(parsedData.step)
            : parsedData.step || {};
    }

    const stepKeys = Object.keys(steps);

    const onFinish = (values) => {
        const currentStepData = values[activeKey];

        console.log("Step hiện tại:", activeKey);
        console.log("Data step hiện tại:", currentStepData);
    };

    if (!steps || stepKeys.length === 0) {
        return <Card>Không có dữ liệu</Card>;
    }
    const formatInitialValues = (steps) => {
      const result = {};

      Object.entries(steps).forEach(([stepKey, fields]) => {
          result[stepKey] = {};

          Object.entries(fields).forEach(([fieldKey, value]) => {

          if (fieldKey.startsWith("checkbox_")) {
              result[stepKey][fieldKey] = [];
          } else {
              result[stepKey][fieldKey] = value;
          }

          });
      });

      return result;
    };
    const initialValues = formatInitialValues(steps);
  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Tabs
          defaultActiveKey={stepKeys[0]}
          onChange={(key) => setActiveKey(key)} // 🔥 lưu tab hiện tại
        >
          {stepKeys.map((stepKey) => (
            <TabPane tab={stepKey} key={stepKey}>
              {Object.entries(steps[stepKey]).map(([fieldKey, value]) => {

                if (fieldKey.startsWith("input_")) {
                  return (
                    <Form.Item
                      key={fieldKey}
                      label={value}
                      name={[stepKey, fieldKey]}
                    >
                      <Input />
                    </Form.Item>
                  );
                }

                if (fieldKey.startsWith("checkbox_")) {
                  return (
                    <Form.Item
                      key={fieldKey}
                      label={value.label}
                      name={[stepKey, fieldKey]}
                    >
                      <Checkbox.Group options={value.options} />
                    </Form.Item>
                  );
                }

                return null;
              })}
            </TabPane>
          ))}
        </Tabs>

        <Button type="primary" htmlType="submit">
          Submit step hiện tại
        </Button>
      </Form>
    </Card>
  );
};

export default DynamicStep;